var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyStash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H7.5V8.29076C6.03408 8.88415 5 10.3213 5 12C5 13.6787 6.03408 15.1159 7.5 15.7092V19H4C2.89543 19 2 18.1046 2 17V7C2 5.89543 2.89543 5 4 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H9V5H15V19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 13.6787 17.9659 15.1159 16.5 15.7092V19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5H16.5V8.29076C17.9659 8.88415 19 10.3213 19 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyStash);
export default __webpack_public_path__ + "static/media/money-stash.d3cfba3f3372c4d876c511651be0dcc2.svg";
export { ForwardRef as ReactComponent };